import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.006 20.5L7 17.311L12 14.125L17 17.311L12 20.499L12.006 20.5ZM17.006 16.249L12.006 13.062L17.006 9.875L12.006 6.689L17.006 3.5L22.006 6.689L17.006 9.875L22.006 13.062L17.006 16.249ZM7 16.249L2 13.062L7 9.875L2 6.689L7 3.5L12 6.689L7 9.874L12 13.061L7 16.249Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dropbox"
);
